module.exports = __webpack_public_path__ + "img/unit11.a790f52e.jpg";